"use client";
import React, { useEffect, useRef } from "react";
import Icon from "@/components/ui/AppIcon";

const schritte = [
  {
    num: "01",
    icon: "ChatBubbleLeftRightIcon",
    title: "Du schreibst mir",
    desc: "Kontaktiere mich per WhatsApp, Instagram oder über das Kontaktformular. Kurze Beschreibung reicht.",
  },
  {
    num: "02",
    icon: "ClipboardDocumentListIcon",
    title: "Wir besprechen alles",
    desc: "Wir klären gemeinsam, was du brauchst – neuer Build, Upgrade oder Reinigung. Ich berate dich ehrlich.",
  },
  {
    num: "03",
    icon: "TruckIcon",
    title: "Du bringst die Teile",
    desc: "Du bringst deine Komponenten oder deinen bestehenden PC vorbei – Standort in der Schweiz.",
  },
  {
    num: "04",
    icon: "CheckBadgeIcon",
    title: "Fertig & getestet",
    desc: "Ich baue, teste und richte alles ein. Du holst deinen fertigen, optimierten PC ab.",
  },
];

export default function AblaufSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("revealed");
        });
      },
      { threshold: 0.1 }
    );
    sectionRef.current?.querySelectorAll(".reveal-hidden").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="ablauf" ref={sectionRef} className="relative py-28 lg:py-36 px-6 lg:px-12 bg-[#0A0A14] overflow-hidden">
      <div className="orb w-[500px] h-[500px] bg-blue-500/5 bottom-0 right-0" />

      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 reveal-hidden">
          <div className="section-label justify-center mb-4">Ablauf</div>
          <h2 className="font-display font-extrabold text-[clamp(2rem,4vw,3.2rem)] text-white leading-tight">
            So einfach{" "}
            <span className="gradient-text-blue">funktioniert es</span>
          </h2>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {schritte.map((s, i) => (
            <div
              key={s.num}
              className="relative reveal-hidden"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              {/* Connector line (desktop) */}
              {i < schritte.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-[calc(50%+32px)] w-[calc(100%-40px)] h-px bg-gradient-to-r from-violet-500/40 to-blue-500/20 z-0" />
              )}

              <div className="service-card flex flex-col gap-5 relative z-10">
                {/* Number + Icon */}
                <div className="flex items-center justify-between">
                  <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-violet-500/20 to-blue-500/10 border border-violet-500/20 flex items-center justify-center">
                    <Icon name={s.icon as any} size={24} className="text-violet-400" />
                  </div>
                  <span className="font-mono text-4xl font-bold text-white/[0.06]">{s.num}</span>
                </div>

                <div>
                  <h3 className="font-display font-bold text-base text-white mb-2">{s.title}</h3>
                  <p className="text-xs text-white/40 leading-relaxed">{s.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}